<template>
  <div v-if="timesheet">
     <page-heading title="Timesheet" :loading="fetching"> -->
      <div slot="buttons">
        <el-row>
          <el-col :span="24" align="right">
            <router-link :to="{ name: 'timesheets' }"><el-button type="info">Back to Timesheets</el-button></router-link>
          </el-col>
        </el-row>
      </div>
    </page-heading>

    <content-placeholder v-if="fetching">
      <el-card>
        <p class="text text-10 text-h-20"></p>
        <p class="text text-full"></p>
        <p class="text text-50"></p>
      </el-card>
    </content-placeholder>

    <div v-else>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-card>
            <div slot="header">
              Status
            </div>
            <div slot="actions">
              <el-tag size="small" :type="setType" effect="dark">{{ setValue }}</el-tag>
            </div>
            <table cellpadding="5" cellspacing="5">
              <tr>
                <td width="150px"><i class="global-icon fas fa-user"></i> Name</td>
                <td>
                  {{ userName(timesheet.user) }}
                </td>
              </tr>
              <tr>
                <td width="150px"><i class="global-icon far fa-calendar-week"></i> Week</td>
                <td>{{ weekNumber }}</td>
              </tr>
              <!--
                <tr>
                  <td width="150px"><i class="global-icon far fa-calendar-week"></i> Week</td>
                  <td>{{ startOfISOWeek | formatTime('W') }}</td>
                </tr>
              -->
              <tr>
                <td width="175px"><i class="global-icon far fa-stopwatch"></i> Total Paid Time</td>
                <td>{{ totalPaidTime | formatDiff }} ({{totalPaidEntries}} entries)</td>
              </tr>
              <tr>
                <td width="175px"><i class="global-icon far fa-stopwatch"></i> Total Worked</td>
                <td>{{ totalWorkedTime | formatDiff }} ({{totalWorkedEntries}} entries)</td>
              </tr>
              <tr>
                <td width="175px"><i class="global-icon far fa-stopwatch"></i> Total BMS Logged</td>
                <td>{{ timesheet.bms_hours | formatDiff('hours')}}</td>
              </tr>
              <tr>
                <td width="175px"><i class="global-icon far fa-stopwatch"></i> Total S/W</td>
                <td>{{ totalSicknessTime | formatDiff }} ({{totalSicknessEntries}} entries)</td>
              </tr>
              <tr>
                <td width="175px"><i class="global-icon far fa-stopwatch"></i> Total PTO</td>
                <td>{{ totalPTOTime | formatDiff }} ({{totalPTOEntries}} entries)</td>
              </tr>
              <tr>
                <td width="175px"><i class="global-icon far fa-stopwatch"></i> Total Federal</td>
                <td>{{ totalFederalTime | formatDiff }} ({{totalFederalEntries}} entries)</td>
              </tr>
              <tr>
                <td width="175px"><i class="global-icon far fa-stopwatch"></i> Total Unpaid Time</td>
                <td>{{ totalUnpaidTime | formatDiff }} ({{totalUnpaidEntries}} entries)</td>
              </tr>
              <tr>
                <td width="150px"><i class="global-icon fas fa-calendar-day"></i> Start Date</td>
                <td>{{ startOfWeek | formatTime('dddd, MMMM Do YYYY') }}</td>
              </tr>
              <tr>
                <td width="150px"><i class="global-icon fas fa-calendar-day"></i> End Date</td>
                <td>{{ endOfWeek | formatTime('dddd, MMMM Do YYYY') }}</td>
              </tr>
              <tr>
                <td width="150px"><i class="global-icon fas fa-user-check"></i> Submitted</td>
                <td>{{ timesheet.created_at | formatTime('MMMM DD, YYYY hh:mm a') }}</td>
              </tr>
              <tr>
                <td width="150px"><i class="global-icon fas fa-user-check"></i> Utilization / Efficiency</td>
                <td>{{ efficiency_percentage.toFixed(2) }} %</td>
              </tr>
            </table>
            <div slot="footer">
              <timesheet-status-buttons :timesheet="timesheet" :onStatusChange="handleOnStatusChange" />
            </div>
          </el-card>
          <comments-list ref="commentsList" :id="timesheetId" type="Timesheet" />
        </el-col>
        <el-col :span="16">
          <div v-for="(day, index) in days" :key="index">
            <time-logs :date="day.date" :userId="timesheet.user_id" :showEdit="true" :showManualEntry="false"></time-logs>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  import moment from 'moment';
  import { mapActions, mapGetters } from 'vuex';
  import TimeLogs from '@/components/timeLog/TimeLogs';
  import TimesheetStatusButtons from '@/components/timesheet/TimesheetStatusButtons';
  import CommentsList from '@/components/comment/CommentsList';
  import durationMixin from '@/store/modules/timeLog/mixins/duration';

  export default {
    name: 'Timesheet',
    components: {
      timesheetStatusButtons: TimesheetStatusButtons,
      timeLogs: TimeLogs,
      commentsList: CommentsList,
    },
    mixins: [durationMixin],
    created() {
      this.fetchSingleTimesheet(this.timesheetId);
    },
    data() {
      return {
        timesheetId: parseInt(this.$router.currentRoute.params.id, 10),
        week: moment().week(),
        year: moment().year(),
      };
    },
    computed: {
      ...mapGetters('entities/timesheets', ['fetching']),
      ...mapGetters('entities/users', ['currentUser']),

      timesheet() {
        return this.$store.getters['entities/timesheets/query']()
          .with('user.profile')
          .where('id', this.timesheetId)
          .first();
      },
      efficiency_percentage() {
        const hours = moment.duration(this.timeLogsDuration(this.filterTimeByeCategory('billing'))).asHours();
        if (hours <= 0) {
          return 0;
        }
        return (this.timesheet.bms_hours / hours) * 100;
      },
      timeLogs() {
        let currentUserId = this.currentUser.id;

        const startDt = moment().isoWeekYear(this.timesheet.year).isoWeek(this.timesheet.week).startOf('isoWeek');
        const endDt = moment().isoWeekYear(this.timesheet.year).isoWeek(this.timesheet.week).endOf('isoWeek');

        if (this.timesheet.user_id) {
          currentUserId = this.timesheet.user_id;
        }

        return this.$store.getters['entities/timeLogs/query']()
          .with('category')
          .where(record => record.stopped_at !== null)
          .where(record => record.user_id === currentUserId)
          .where(record => moment(record.started_at).isBetween(startDt, endDt))
          .where('deleted', false)
          .orderBy('started_at', 'asc')
          .get();
      },

      totalPaidTime() {
        return this.timeLogsDuration(this.timeLogs.filter(timeLog => timeLog.category.name !== 'Unpaid'));
      },
      totalWorkedTime() {
        return this.timeLogsDuration(this.filterTimeByeCategory('billing'));
      },
      totalSicknessTime() {
        return this.timeLogsDuration(this.filterTimeByeCategory('sickness'));
      },
      totalPTOTime() {
        return this.timeLogsDuration(this.filterTimeByeCategory('pto'));
      },
      totalFederalTime() {
        return this.timeLogsDuration(this.filterTimeByeCategory('holiday'));
      },
      totalUnpaidTime() {
        return this.timeLogsDuration(this.timeLogs.filter(timeLog => timeLog.category.name === 'Unpaid'));
      },

      totalPaidEntries() {
        const paidEntries = this.timeLogs.filter(timeLog => timeLog.category.name !== 'Unpaid');
        return paidEntries ? paidEntries.length : 0;
      },

      totalUnpaidEntries() {
        const unpaidEntries = this.timeLogs.filter(timeLog => timeLog.category.name === 'Unpaid');
        return unpaidEntries ? unpaidEntries.length : 0;
      },
      totalWorkedEntries() {
        return this.filterTimeByeCategory('billing').length;
      },
      totalSicknessEntries() {
        return this.filterTimeByeCategory('sickness').length;
      },
      totalPTOEntries() {
        return this.filterTimeByeCategory('pto').length;
      },
      totalFederalEntries() {
        return this.filterTimeByeCategory('holiday').length;
      },
      startOfISOWeek() {
        return moment(`${this.timesheet.week} ${this.timesheet.year}`, 'WW gggg').startOf('isoWeek');
      },
      endOfISOWeek() {
        return moment(`${this.timesheet.week} ${this.timesheet.year}`, 'WW gggg').endOf('isoWeek');
      },

      startOfWeek() {
        return moment().isoWeekYear(this.timesheet.year).isoWeek(this.timesheet.week).startOf('isoWeek');
      },
      endOfWeek() {
        return moment().isoWeekYear(this.timesheet.year).isoWeek(this.timesheet.week).endOf('isoWeek');
      },
      weekNumber() {
        // We are not going to show isoWeek for leap year. This no longer seems to be desired as
        // it is yielding unwanted results [mln]

        // if (moment([this.timesheet.year]).isLeapYear()) {
        //   return moment().year(this.timesheet.year)
        //                  .week(this.timesheet.week)
        //                  .startOf('isoWeek')
        //                  .week();
        // } else {
        //   return moment().year(this.timesheet.year)
        //                  .week(this.timesheet.week)
        //                  .startOf('week')
        //                  .week();
        // }

        return moment().isoWeekYear(this.timesheet.year)
                       .isoWeek(this.timesheet.week)
                       .startOf('isoWeek')
                       .isoWeek();
      },

      days() {
        const daysCount = 7;
        const days = [];
        const base = moment().isoWeekYear(this.timesheet.year).isoWeek(this.timesheet.week).startOf('isoWeek');

        for (let i = 0; i < daysCount; i += 1) {
          days.push({
            day: i + 1,
            date: base.clone().add(i, 'days'),
          });
        }

        return days;
      },

      setType() {
        if (this.timesheet) {
          switch (this.timesheet.status) {
            case 'approved':
              return 'success';
            case 'rejected':
              return 'danger';
            case 'pending':
              return 'warning';
            default:
              return 'info';
          }
        }
        return 'info';
      },
      setValue() {
        if (this.timesheet) {
          switch (this.timesheet.status) {
            case 'approved':
              return 'Approved';
            case 'rejected':
              return 'Rejected';
            case 'pending':
              return 'Pending';
            default:
              return 'Not Submitted';
          }
        }
        return 'Not Submitted';
      },
    },
    methods: {
      ...mapActions('entities/timesheets', ['fetchSingleTimesheet']),
      filterTimeByeCategory(category) {
        return this.timeLogs.filter(timeLog => this.getMappedCategory(timeLog.category) === category) || [];
      },
      getMappedCategory(category) {
        let type = category.type.toLowerCase().split('category')[0];
        if (type === 'pto') {
          const categoryName = category.name.toLowerCase();
          if (categoryName.includes('sickness')) {
            type = 'sickness';
          } else if (categoryName.includes('unpaid')) {
            type = 'unpaid';
          }
        }
        return type;
      },
      userName(user) {
        return (user.profile) ? `${user.profile.first_name} ${user.profile.last_name}` : user.email;
      },

      handleOnStatusChange(response, data) {
        // Status has been changes with comment
        if (data.comments_attributes) {
          this.$refs.commentsList.fetchCommentsForCommentable();
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/pages/Timesheet.vue